import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onCatalogOptionClick"];
import { useState } from 'react';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { FilterIcon } from 'foundations-assets/icons/components/FilterIcon';
import { CatalogPanel } from './CatalogPanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ACCatalogFilterButton = _ref => {
  let {
      onCatalogOptionClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isCatalogOpen, setIsCatalogOpen] = useState(false);
  const toggleCatalog = () => {
    setIsCatalogOpen(prev => !prev);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(IconButton, Object.assign({
      "data-test-id": "mobile-catalog-filter-button",
      onClick: toggleCatalog,
      paddingInline: "200"
    }, rest, {
      children: /*#__PURE__*/_jsx(FilterIcon, {})
    })), /*#__PURE__*/_jsx(CatalogPanel, {
      isOpen: isCatalogOpen,
      onCatalogOptionClick: onCatalogOptionClick,
      onRemoveButtonClick: toggleCatalog
    })]
  });
};